const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const sendMessage = async (message, threadId, signal, token, maxRetries = 3, retryDelayMs = 1000) => {
  let attempt = 0;

  const payload = {
    message,
    threadId: threadId || null,
  };

  while (attempt <= maxRetries) {
    try {
      const response = await fetch(`${API_BASE_URL}/getAnswer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
        signal,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      return data;

    } catch (error) {
      if (error.name === "AbortError") {
        console.warn("Request aborted:", error);
        throw error;
      }

      if (attempt >= maxRetries) {
        console.error("Final attempt failed:", error);
        throw error;
      }

      console.warn(`Attempt ${attempt + 1} failed. Retrying in ${retryDelayMs}ms...`, error);
      await new Promise((resolve) => setTimeout(resolve, retryDelayMs));
      attempt++;
    }
  }
};

export const validateToken = async (token) => {
  try {
    const response = await fetch(`${API_BASE_URL}/authCheck`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Token validation failed. Status: ${response.status}`);
    }

    const data = await response.json();
    return data.userType;
  } catch (error) {
    console.error("Error validating token:", error);
    return null;
  }
};

export const userUploadFile = async (file, token) => {
  try {
    const arrayBuffer = await file.arrayBuffer();

    const response = await fetch(`${API_BASE_URL}/userUploadFile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/octet-stream",
        "x-filename": file.name,
        Authorization: `Bearer ${token}`,
      },
      body: arrayBuffer,
    });

    if (!response.ok) {
      throw new Error(`File upload failed. Status: ${response.status}`);
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};

export async function listOpenAiVectorStoreFiles(token) {
  const response = await fetch(`${API_BASE_URL}/listOpenAiVectorStoreFiles`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const text = await response.text();

  if (!response.ok) {
    throw new Error("Failed to fetch files");
  }

  const result = JSON.parse(text);

  return result;
}

export async function searchByFileName(token, fileName) {
  const response = await fetch(`${API_BASE_URL}/searchByFileName/${fileName}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch files");
  }

  const result = await response.json()
  return result;
}

export async function deleteVectorStoreFileById(fileId, token) {
  try {
    const response = await fetch(`${API_BASE_URL}/deleteVectorStoreFileById/${fileId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to delete file. Status: ${response.status}`);
    }
  } catch (error) {
    console.error("Error deleting file:", error);
    throw error;
  }
}

export async function deleteFileById(fileId, token) {
  try {
    const response = await fetch(`${API_BASE_URL}/deleteFileById/${fileId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to delete file. Status: ${response.status}`);
    }
  } catch (error) {
    console.error("Error deleting file:", error);
    throw error;
  }
}